class StellaRecommend extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // console.log("STELLA RECOMMEND CONNECTED");
    this.init();

    let debounceTimer;
    this.observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
              if ((node.matches && node.matches('.stella-target')) || (node.querySelector && node.querySelector('.stella-target'))) {
                shouldUpdate = true;
                break;
              }
            }
          }
        }
        if (shouldUpdate) break;
      }

      if (shouldUpdate) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          this.init();
        }, 100);
      }
    });
    // Observe the body for structural updates, but only react to .stella-target insertions
    this.observer.observe(document.body, { childList: true, subtree: true });

    // Listen for variant changes (e.g. when a user clicks a variant radio button)
    this.changeHandler = (e) => {
      if (e.target && e.target.matches && e.target.matches('input.reco__input-variant')) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          this.init();
        }, 50);
      }
    };
    document.addEventListener('change', this.changeHandler);
  }

  init() {
    const rawData = localStorage.getItem('stellaRecommendedProductVariants');

    const targets = document.querySelectorAll('.stella-target');
    if (targets.length > 0) {
      const availableRadioInputs = new Set();
      targets.forEach(target => {
        const inputs = target.querySelectorAll('input.reco__input-variant');
        inputs.forEach(input => availableRadioInputs.add(input));
      });
      
      const matchedInputs = new Set();
      let variantIds = [];
      
      if (rawData) {
        try {
          const parsed = JSON.parse(rawData);
          if (Array.isArray(parsed)) {
            variantIds = parsed.map(item => item.variant_id || item.id || item);
          } else {
            variantIds = [parsed.variant_id || parsed.id || parsed];
          }
        } catch(e) {
          variantIds = rawData.split(',');
        }
      }

      // Ensure we extract just the numeric ID in case it's a global Shopify ID
      variantIds = variantIds.map(id => {
        const match = String(id).match(/(\d+)$/);
        return match ? match[1] : String(id);
      }).filter(Boolean);

      availableRadioInputs.forEach(input => {
        const dataId = input.dataset.id || input.getAttribute('data-id');
        const cleanDataId = dataId && dataId.match(/(\d+)$/) ? dataId.match(/(\d+)$/)[1] : dataId;

        if (cleanDataId && variantIds.includes(cleanDataId)) {
          matchedInputs.add(input);
        }
      });

      // console.log("MATCHED INPUTS: ", matchedInputs);
      const template = document.getElementById('stella-recommend-template');
      if (template) {
        matchedInputs.forEach(input => {
          this.applyBadgeToParent(input, template);
        });
      }
    }
  }

  applyBadgeToParent(el, template) {
    if (!el || !template) return;
    const parent = el.parentElement;
    
    if (parent && !parent.classList.contains('has-stella-badge')) {
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.classList.add('has-stella-badge');
      const clone = template.content.cloneNode(true);
      parent.appendChild(clone);
    }
  }

  disconnectedCallback() {
    // console.log("STELLA RECOMMEND DISCONNECTED");
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.changeHandler) {
      document.removeEventListener('change', this.changeHandler);
    }
  }
}

if (!customElements.get('stella-recommend')) {
  customElements.define('stella-recommend', StellaRecommend);
}
